// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBfPdtBottgTRXSRjETwmjQ__9TNe-6CUU",
  authDomain: "university-confessions-62498.firebaseapp.com",
  projectId: "university-confessions-62498",
  storageBucket: "university-confessions-62498.appspot.com",
  messagingSenderId: "9692603234",
  appId: "1:9692603234:web:241363c1c8056babbdc23b",
  measurementId: "G-LPYBREQLMX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);

// connectFirestoreEmulator(db, 'localhost', 8080);
// connectAuthEmulator(auth, "http://localhost:8080");
export const provider = new GoogleAuthProvider();